// removed by extract-text-webpack-plugin
module.exports = {"component":"xq7w9Yet0VbGLH1mmEsBZ","messagePlaceholder":"_1I_42wU3UvXVYHWZOEnpFs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Messages/MessageThreadHeaderList/MessageThreadHeaderList.css
// module id = 1322
// module chunks = 0